import { extend, setInteractionMode } from 'vee-validate';
import { email, min, max, required } from 'vee-validate/dist/rules';

setInteractionMode('passive');

/**
 * Regel für Pflichtfelder.
 */
extend('required', {
  ...required,
  message: 'Dieses Feld ist eine Pflichtangabe',
});

/**
 * Regel für die Überprüfung, ob eine Checkbox angehakt ist.
 * Die Vuetify-Checkboxen setzen die Werten nicht auf {@code true}/{@code false},
 * sondern auf '1' bzw. '0' als String.
 */
extend('checked', {
  validate: value => value === '1',
  message: 'Sie müssen diese Angabe bestätigen, um fortfahren zu können',
});

/**
 * Regel für valide E-Mail-Adressen
 */
extend('email', {
  ...email,
  message: 'Es wurde keine gültige E-Mail-Adresse angegeben',
});

/**
 * Regel für die Mindestanzahl der Zeichen, die in einem Feld eingegeben werden müssen.
 */
extend('min', {
  ...min,
  message: 'Die Mindestzeichenlänge ist nicht erreicht',
});

extend('max', {
  ...max,
  message: 'Die maximale Länge wurde überschritten',
});

/**
 * Regel für die ING-Vermittlernummer.
 * Diese muss genau zehn Zeichen lang und numerisch sein.
 * Das die Eingabe numerisch ist, stellt bereits das Eingabefeld selber sicher.
 */
extend('ingVermittlernummer', {
  message:
    'Unbekannte ING-Vermittlernummer. Bitte wenden Sie sich an das Partner-Management der ING.',
  validate: value => value.length === 10,
});

extend('plz', {
  message: 'keine gültige Postleitzahl',
  validate: value => /^\d{5}$/.test(value),
});
